{
  "locale": "hu",
  "nationalities": {
    "AF": "afgán",
    "AL": "albán",
    "DZ": "algériai",
    "AD": "andorrai",
    "AO": "angolai",
    "AG": "antiguai",
    "AR": "argentín",
    "AM": "örmény",
    "AU": "ausztrál",
    "AT": "osztrák",
    "AZ": "azerbajdzsán",
    "BS": "bahamai",
    "BH": "bahreini",
    "BD": "bangladeshi",
    "BB": "barbiduai",
    "BY": "belorusz",
    "BE": "belga",
    "BZ": "belizi",
    "BJ": "benini",
    "BM": "bermudai",
    "BT": "butáni",
    "BO": "bolivíai",
    "BA": "Bosznia-hercegoviani",
    "BW": "botswanai",
    "BV": "Bouvet-szigeti",
    "BR": "brazil",
    "IO": "Brit Indiai-óceán területi",
    "BN": "brunei",
    "BG": "bulgár",
    "BF": "burkinabei",
    "BI": "burundi",
    "KH": "kambodzsai",
    "CM": "kameruni",
    "CA": "canadai",
    "CV": "Verdea foki",
    "KY": "Cayman szigeti",
    "CF": "közép afrikai",
    "TD": "csaádi",
    "CL": "csílei",
    "CN": "kínai",
    "CX": "karácsony szigeteki",
    "CC": "kokus szigeteki",
    "CO": "kolumbiai",
    "KM": "comorai",
    "CG": "kongolézi",
    "CD": "kongolézi",
    "CK": "Cook szigeteki",
    "CR": "costa ricai",
    "CI": "ivori",
    "HR": "horvát",
    "CU": "kubai",
    "CY": "ciprusi",
    "CZ": "cseh",
    "DK": "dán",
    "DJ": "dzsibuti",
    "DM": "dominikai",
    "DO": "dominikai",
    "EC": "ekvádori",
    "EG": "egyiptomi",
    "SV": "szalvadori",
    "GQ": "egyenlítő gíneai",
    "ER": "eritreai",
    "EE": "észt",
    "ET": "etióp",
    "FK": "Falkland szigeteki",
    "FO": "Faroe szigeteki",
    "FJ": "fidzsi",
    "FI": "finn",
    "FR": "francia",
    "GF": "francia",
    "PF": "francia",
    "TF": "francia",
    "GA": "gaboni",
    "GM": "gambiai",
    "GE": "grúz",
    "DE": "német",
    "GH": "gánai",
    "GI": "gibraltári",
    "GR": "görög",
    "GL": "greenlandi",
    "GD": "grenadiai",
    "GP": "guadeloupei",
    "GU": "guami",
    "GT": "guatemalai",
    "GN": "gíneai",
    "GW": "Guinea-Bissauan-i",
    "GY": "gayanai",
    "HT": "haiti",
    "HM": "Heard szigeti és Mcdonald szigeti",
    "VA": "vatikáni",
    "HN": "hondurasi",
    "HK": "Hong Kong-i",
    "HU": "Magyar",
    "IS": "izlandi",
    "IN": "indiai",
    "ID": "indonáz",
    "IR": "iráni",
    "IQ": "iraki",
    "IE": "ír",
    "IL": "izraeli",
    "IT": "olasz",
    "JM": "jamaikai",
    "JP": "japán",
    "JO": "jordán",
    "KZ": "kazah",
    "KE": "kenyai",
    "KI": "I-Kiribati",
    "KP": "észak koreai",
    "KR": "dél koreai",
    "KW": "kuvaiti",
    "KG": "kirgíz",
    "LA": "laoszi",
    "LV": "litván",
    "LB": "libanoni",
    "LS": "mosothoi",
    "LR": "libériai",
    "LY": "líbiai",
    "LI": "lichtensteni",
    "LT": "litván",
    "LU": "luxemburgi",
    "MO": "makaoi",
    "MG": "malagazi",
    "MW": "malawi",
    "MY": "maláj",
    "MV": "maldíviai",
    "ML": "mali",
    "MT": "máltai",
    "MH": "Marshall szigeteki",
    "MQ": "martiniki",
    "MR": "mauritániai",
    "MU": "mauritiusi",
    "YT": "Mayotte-i",
    "MX": "mexikói",
    "FM": "mikronéziai",
    "MD": "moldovai",
    "MC": "monaco-i",
    "MN": "mongol",
    "MS": "Montserrat-i",
    "MA": "marokkó",
    "MZ": "mozambiki",
    "MM": "burmai",
    "NA": "namíbiai",
    "NR": "naurui",
    "NP": "nepáli",
    "NL": "holland",
    "NC": "új-kaledóniai",
    "NZ": "új-zélandi",
    "NI": "nikaraguai",
    "NE": "nigériai",
    "NG": "nigeri",
    "NU": "Niue-i",
    "NF": "Norfolk szigeti",
    "MK": "makedón",
    "MP": "Északi Mariana szigeti",
    "NO": "norvég",
    "OM": "ománi",
    "PK": "pakisztáni",
    "PW": "Palauan-i",
    "PS": "Palestinian területi",
    "PA": "panamai",
    "PG": "Papua Új Guinea-i",
    "PY": "paraguayi",
    "PE": "perui",
    "PH": "filippinó",
    "PN": "Pitcairn-i",
    "PL": "lengyel",
    "PT": "portugál",
    "PR": "Puerto Rico-i",
    "QA": "Qatari",
    "RE": "Reunion-i",
    "RO": "román",
    "RU": "orosz",
    "RW": "ruandai",
    "SH": "Saint Helena-i",
    "KN": "Kittiai és Nevisiai",
    "LC": "Saint Lucian-i",
    "PM": "Saint Pierre és Miquelon-i",
    "VC": "Saint Vincent és Grenadines-i",
    "WS": "szamoai",
    "SM": "San Marino-i",
    "ST": "Sao Tomean-i",
    "SA": "szaudi",
    "SN": "szenegáli",
    "SC": "Seychellois-i",
    "SL": "Sierra Leone-i",
    "SG": "szingapúri",
    "SK": "szlovák",
    "SI": "szlovén",
    "SB": "Solomon szigeteki",
    "SO": "szomáli",
    "ZA": "dél-afrikai",
    "GS": "South Georgia és South Sandwich szigeteki",
    "ES": "spanyol",
    "LK": "ceyloni",
    "SD": "szudáni",
    "SR": "Suriname-i",
    "SJ": "Svalbard és Jan Mayen-i",
    "SZ": "szwázi",
    "SE": "svéd",
    "CH": "svájci",
    "SY": "szíriai",
    "TW": "tajvani",
    "TJ": "tadzsik",
    "TZ": "tanzániai",
    "TH": "thai",
    "TL": "East Timorese-i",
    "TG": "Togolese-i",
    "TK": "Tokelau-i",
    "TO": "Tongai",
    "TT": "Trinidadi és Tobagoi",
    "TN": "tunéziai",
    "TR": "török",
    "TM": "türkmén",
    "TC": "Turks és Caicos szigeti",
    "TV": "tuvalui",
    "UG": "ugandai",
    "UA": "ukrán",
    "AE": "emirátusi",
    "GB": "angol",
    "US": "amerikai",
    "UM": "United States Minor Outlying szigeti",
    "UY": "urugayi",
    "UZ": "üzbég",
    "VU": "Vanuatu-i",
    "VE": "venezuleai",
    "VN": "vietnami",
    "VG": "Virgin szigeteki, angol",
    "VI": "Virgin szigeteki, amerikai",
    "WF": "welszi",
    "EH": "Western Sahara-i",
    "YE": "yemeni",
    "ZM": "zambiai",
    "ZW": "zimbabwei",
    "AX": "Åland szigeteki",
    "BQ": "Bonaire, Sint Eustatius és Saba-i",
    "CW": "Curaçao-i",
    "GG": "Guernsey-i",
    "IM": "Man szigeteki",
    "JE": "Jersey-i",
    "ME": "montenegrói",
    "BL": "Saint Barthélemy-i",
    "MF": "Saint Martin-i (francia)",
    "RS": "szerb",
    "SX": "Sint Maarten-i (holland)",
    "SS": "dél-szudáni",
    "XK": "koszovói"
  }
}
